import { FEATURES_NAME } from "./features";

// Data to create Pricelist item - PBook popup 1st screen

export const PRICEBOOK_FORM_DATA = [
  {
    label: "Select Product",
    name: "product",
    type: "singleSelect",
    required: true,
    standard: true,
    defaultVal: "",
    span: "full",
    visibility: true,
    order: 0,
    applicable: true,
  },
  {
    label: "Charge Type",
    name: "charge_type",
    type: "singleSelect",
    required: true,
    standard: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
  },
  {
    label: "Charge Frequency",
    name: "charge_frequency",
    type: "singleSelect",
    required: false,
    standard: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
  },
  {
    label: "Billing Frequency",
    name: "billing_frequency",
    type: "singleSelect",
    required: false,
    standard: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
  },
  {
    label: "Minimum Selling Term",
    name: "selling_term",
    type: "numberColumn",
    required: false,
    standard: true,
    defaultVal: 1,
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
  },
  {
    label: "Recurring Period",
    name: "recurring_period",
    type: "singleSelect",
    required: false,
    standard: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
  },
  {
    label: "Metric",
    name: "scale",
    type: "numberColumn",
    required: false,
    standard: true,
    defaultVal: 1,
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
  },
  {
    label: "UoM",
    name: "uom",
    type: "singleSelect",
    required: true,
    standard: true,
    defaultVal: "Unit",
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
  },
  // Dates here
  {
    label: "Effective Date",
    name: "effective_date",
    type: "dateColumn",
    required: false,
    standard: true,
    defaultVal: {
      currentDate: true,
    },
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
  },
  {
    label: "Expiry Date",
    name: "expiry_date",
    type: "dateColumn",
    required: false,
    standard: true,
    defaultVal: {
      currentDate: false,
      increment: "years",
      incrementBy: 1,
    },
    // defaultVal: {
    //   currentDate: true,
    // },
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
  },
  {
    label: "Default Quantity",
    name: "default_qty",
    type: "numberColumn",
    required: false,
    standard: true,
    defaultVal: 1,
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
  },
  {
    label: "Minimum Quantity",
    name: "min_qty",
    type: "numberColumn",
    required: false,
    standard: true,
    defaultVal: 0,
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
  },
  {
    label: "Max Usage",
    name: "max_usage",
    type: "numberColumn",
    required: false,
    standard: true,
    defaultVal: 0,
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
  },
  {
    label: "Max Usage UoM",
    name: "max_usage_uom",
    type: "singleSelect",
    required: false,
    standard: true,
    defaultVal: "Unit",
    span: "half",
    visibility: true,
    order: 1,
    applicable: true,
    disabled: true,
  },
  {
    label: "Remarks",
    name: "remarks",
    type: "text",
    required: false,
    standard: true,
    defaultVal: "",
    span: "full",
    visibility: true,
    order: 1,
    applicable: true,
  },
  {
    label: "Active",
    name: "active",
    type: "checkbox",
    required: false,
    standard: true,
    defaultVal: true,
    span: "full",
    visibility: false,
    order: 1,
    applicable: true,
  },
];

// Price related fileds data - PBook popup 2nd screen
export const PRICING_METHOD_FLATPRICE_DATA = [
  {
    defaultVal: "",
    label: "UOM OF THE RANGE",
    name: "quantity_uom",
    order: 0,
    required: false,
    span: "full",
    standard: true,
    type: "singleSelect",
    visibility: true,
    applicable: true,
  },
  {
    defaultVal: "",
    isCurrency: true,
    label: "List Price",
    name: "price",
    order: 1,
    placeHolder: "Enter Price Per Unit",
    required: true,
    span: "half",
    standard: true,
    type: "priceMatrixColumn",
    visibility: true,
    applicable: true,
  },
  {
    defaultVal: 0,
    isCurrency: true,
    label: "Minimum Price",
    name: "min_price",
    order: 2,
    required: false,
    span: "half",
    standard: true,
    type: "numberColumn",
    visibility: true,
    applicable: true,
  },
  {
    defaultVal: 0,
    isCurrency: true,
    label: "Maximum Price",
    name: "max_price",
    order: 3,
    required: false,
    span: "half",
    standard: true,
    type: "numberColumn",
    visibility: true,
    applicable: true,
  },
  {
    defaultVal: 0,
    isCurrency: true,
    label: "Cost Price",
    name: "cost_price",
    order: 4,
    required: false,
    span: "half",
    standard: true,
    type: "numberColumn",
    visibility: true,
    applicable: true,
  },
];

// Pricing Methods Data - PBook popup 2nd screen
export const PRICING_TYPES = [
  {
    alias: "flat",
    description: "Flat price description",
    label: "Flat Price",
    featureIgnore: true,
  },
  {
    alias: "tier",
    description: "The prices are assigned to quantity-based ranges",
    label: "Tier Pricing",
    featureIgnore: true,
  },
  {
    alias: "volume",
    description: "The price is quantity-based",
    label: "Volume Pricing",
    featureIgnore: true,
  },
  {
    alias: "step-tier",
    description: "Flat price for every range",
    label: "Step-Tier Pricing",
    featureIgnore: true,
  },
  {
    alias: "bundle",
    description: "Bundle Pricing",
    label: "Bundle Pricing",
    featureName: FEATURES_NAME.QUOTING_BUNDLE_PRICING,
    featureIgnore: false,
  },
  {
    alias: "percentageOfTotal",
    description: "Percentage of Total",
    label: "Percentage of Total",
    featureIgnore: true,
  },
  {
    alias: "diyPricing",
    description: "Do It Yourself",
    label: "DIY Pricing",
    featureName: FEATURES_NAME.QUOTING_DIY_PRICING,
    featureIgnore: false,
  },
];

// Pricing Methods MetaData - PBook popup 2nd screen
export const PRICING_TYPES_MAP = {
  "Bundle Pricing": "bundle",
  "DIY Pricing": "diyPricing",
  "Flat Price": "flat",
  "Non Linear": "bundle",
  "Percentage of Total": "percentageOfTotal",
  "Step-Tier Pricing": "matrix",
  "Tier Pricing": "matrix",
  "Volume Pricing": "matrix",
};

export const BUNDLE_TYPES = [
  {
    alias: "basic",
    description: "",
    label: "BASIC BUNDLE",
  },
  {
    alias: "adhoc",
    description:
      "Marking this as AD HOC will allow users to cofigure EFFORT in Deal Table",
    label: "AD HOC SKU",
  },
  {
    alias: "non-linear",
    description:
      "Choose this option if the effort of each resource changes independently with change in quantity",
    label: "NON LINEAR SKU",
  },
];

// Extra fileds needed in matrix selection - PBook popup 2nd screen
export const PRICING_METHOD_MATRIX_DATA = [
  {
    defaultVal: "",
    label: "UOM OF THE RANGE",
    name: "quantity_uom",
    order: 0,
    required: true,
    span: "full",
    standard: true,
    type: "singleSelect",
    visibility: true,
    applicable: true,
  },
];

// To Ctrl DealTable Columns - PBook popup 3rd screen
export const PRICEBOOK_META_DATA = [
  {
    label: "Quantity Editable",
    name: "qty_editable",
    type: "checkbox",
    required: false,
    standard: true,
    defaultVal: true,
    span: "full",
    visibility: true,
    order: 1,
    disabled: false,
    applicable: true,
  },
  {
    label: "Renewable",
    name: "is_renewable",
    type: "checkbox",
    required: false,
    standard: true,
    defaultVal: true,
    span: "full",
    visibility: true,
    order: 1,
    disabled: false,
    applicable: true,
  },
  {
    label: "Selling Term Editable",
    name: "sellingterm_editable",
    type: "checkbox",
    required: false,
    standard: true,
    defaultVal: true,
    span: "full",
    visibility: true,
    order: 1,
    disabled: false,
    applicable: true,
  },
  {
    label: "SKU Quantity Editable",
    name: "sku_quantity_editable",
    type: "checkbox",
    required: false,
    standard: true,
    defaultVal: true,
    span: "full",
    visibility: true,
    order: 1,
    disabled: false,
    applicable: true,
  },
  {
    label: "Billing Frequency Editable",
    name: "billing_frequency_editable",
    type: "checkbox",
    required: false,
    standard: true,
    defaultVal: true,
    span: "full",
    visibility: true,
    order: 1,
    disabled: false,
    applicable: true,
  },
  {
    label: "Hide In Catalog Search",
    name: "hide_in_catalog_search",
    type: "checkbox",
    required: false,
    standard: true,
    defaultVal: false,
    span: "full",
    visibility: true,
    order: 1,
    disabled: false,
    applicable: true,
  },
];

// PBook popup 4rth screen for clauses
export const PRICEBOOK_CLAUSE_DATA = [
  {
    label: "Clauses",
    name: "clauses",
    type: "singleSelect",
    multiSelect: true,
    required: false,
    standard: true,
    defaultVal: [],
    span: "full",
    visibility: true,
    order: 1,
    applicable: true,
  },
];

// Below Map tells which field (the key) is to be not applicable in case what values ( the value - array) of charge_type
export const NOT_APPLICABLE_WRT_CHARGETYPE_MAP = {
  charge_frequency: ["One Time", "Evergreen", "Usage One-Time"],
  selling_term: ["Evergreen", "Usage One-Time"],
  recurring_period: ["Evergreen", "Usage One-Time"],
  max_usage: ["One Time", "Evergreen", "Recurring"],
};

export const PB_FIELD_DB_DEFAULT_VALUES = {
  charge_frequency: "",
  selling_term: 0,
  recurring_period: "",
  max_usage: 0,
  max_usage_uom: "",
};

export const QUANTITY_UOM_BLANK_OPTION = "----------";

export const POSSIBLE_REQUIRED_FIELDS = [
  "product",
  "charge_type",
  "charge_frequency",
  "selling_term",
  "recurring_period",
  "uom",
];
